import React from 'react'
import AdvancedSearch from '../advanced-search'

const AdvancedSearchNo = () => {
    return <AdvancedSearch languageCode="no" />
}

export default AdvancedSearchNo
